"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../styles/components"));

var _PanelContext = _interopRequireDefault(require("./PanelContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Panel = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Panel, _React$Component);

  function Panel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Panel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        title = _this$props.title,
        loading = _this$props.loading,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style;
    var _this$context = this.context,
        stackSize = _this$context.stackSize,
        nextPanel = _this$context.nextPanel;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].Panel, {
      style: style
    }, !!title && /*#__PURE__*/_react["default"].createElement(_components["default"].PanelHeader, null, title), /*#__PURE__*/_react["default"].createElement(_components["default"].PanelBody, null, children));
  };

  return Panel;
}(_react["default"].Component);

_defineProperty(Panel, "contextType", _PanelContext["default"]);

var _default = Panel;
exports["default"] = _default;